/**
 * External dependencies
 */
import { WMUAjaxQuery } from '@wakemeup/ajax-query';

/**
 * 
 */
class WMUBlockArchive extends WMUAjaxQuery {

	/**
	 * 
	 */
	static loadMoreModeIds = {
		SCROLL: 'scroll',
		BUTTON: 'button',
		PAGINATE: 'paginate',
	};

	/**
	 * 
	 */
	constructor( element, args = {} )
	{
		const {
			filterInputSelector = '',
			filterResetSelector = '',
			filtersFormSelector = '',
			highlights = false,
			highlightsWrapperSelector = '',
			itempWrapperSelector = '',
			loadMoreMode = WMUBlockArchive.loadMoreModeIds.SCROLL,
			resetQueryTimeoutDelay = 750,
			viewports = [],
		} = args;

		super( args );

		this.element = element;
		this.filterInputSelector = filterInputSelector;
		this.filterResetSelector = filterResetSelector;
		this.filtersFormSelector = filtersFormSelector;
		this.highlights = highlights;
		this.highlightsWrapperSelector = highlightsWrapperSelector;
		this.itemElements = [];
		this.itempWrapperSelector = itempWrapperSelector
		this.loadMoreMode = loadMoreMode;
		this.resetQueryTimeoutDelay = resetQueryTimeoutDelay;
		this.resetQueryTimeoutID = null;
		this.viewports = viewports;

		if ( undefined !== this.queryArgs.master_tax_query )
		{
			this.masterTaxQuery = this.queryArgs.master_tax_query;
			delete this.queryArgs.master_tax_query;
		}

		this._filterInputElementList = null;
		this._filterResetElement = null;
		this._filtersFormElement = null;
		this._itemWrapperElement = null;
		this._highlightsWrapperElement = null;

		this.isFirstLoadDone = false;

		// console.log( 'BlockArchive.construct', this.element );

		this.writeFiltersData();
		this.initBehaviors();
		this.checkFirstLoad();
	}

	/**
	 * 
	 */
	get filterInputElementList()
	{
		if ( null === this._filterInputElementList && this.filterInputSelector )
		{
			this._filterInputElementList = this.element.querySelectorAll( this.filterInputSelector );
		}

		return this._filterInputElementList;
	}

	/**
	 * 
	 */
	get filterResetElement()
	{
		if ( null === this._filterResetElement && this.filterResetSelector )
		{
			this._filterResetElement = this.element.querySelector( this.filterResetSelector );
		}

		return this._filterResetElement;
	}

	/**
	 * 
	 */
	get filtersFormElement()
	{
		if ( null === this._filtersFormElement && this.filtersFormSelector )
		{
			this._filtersFormElement = this.element.querySelector( this.filtersFormSelector );
		}

		return this._filtersFormElement;
	}

	/**
	 * 
	 */
	get highlightsWrapperElement()
	{
		if ( null === this._highlightsWrapperElement && this.highlightsWrapperSelector )
		{
			this._highlightsWrapperElement = this.element.querySelector( this.highlightsWrapperSelector );
		}

		return this._highlightsWrapperElement;
	}

	/**
	 * 
	 */
	get itemWrapperElement()
	{
		if ( null === this._itemWrapperElement && this.itempWrapperSelector )
		{
			this._itemWrapperElement = this.element.querySelector( this.itempWrapperSelector );
		}

		return this._itemWrapperElement;
	}

	/**
	 * 
	 */
	initBehaviors()
	{
		this.onFilterFormSubmit = this.onFilterFormSubmit.bind( this );
		this.onFilterInputChange = this.onFilterInputChange.bind( this );
		this.onFilterResetClick = this.onFilterResetClick.bind( this );
		this.onResetQueryTimeout = this.onResetQueryTimeout.bind( this );
		this.onWindowScroll = this.onWindowScroll.bind( this );

		window.addEventListener( 'scroll', this.onWindowScroll );

		this.initFilterInputBehaviors();
		this.initFilterResetBehavior();
	}

	/**
	 * 
	 */
	initFilterInputBehaviors()
	{
		if ( null !== this.filtersFormElement && null != this.filterInputElementList )
		{
			this.filterInputElementList.forEach( ( element ) =>
			{
				element.wmuBlockArchiveInitValue = element.value;
				element.addEventListener( 'change', this.onFilterInputChange );
			} );

			this.filtersFormElement.addEventListener( 'submit', this.onFilterFormSubmit );
		}
	}

	/**
	 * 
	 */
	initFilterResetBehavior()
	{
		if ( null !== this.filterResetElement )
		{
			this.filterResetElement.addEventListener( 'click', this.onFilterResetClick );
		}
	}

	/**
	 * 
	 */
	clear()
	{
		this.clearItemElements();
		window.removeEventListener( 'scroll', this.onWindowScroll );
		this.clearFilterInputBehaviors();
		this.clearFilterResetBehavior();

		super.clear();
	}

	/**
	 * 
	 */
	clearFilterInputBehaviors()
	{
		if ( null !== this.filtersFormElement && null != this.filterInputElementList )
		{
			this.filterInputElementList.forEach( ( element ) =>
			{
				element.removeEventListener( 'change', this.onFilterInputChange );
			} );

			this.filtersFormElement.removeEventListener( 'submit', this.onFilterFormSubmit );
		}
	}

	/**
	 * 
	 */
	clearFilterResetBehavior()
	{
		if ( null !== this.filterResetElement )
		{
			this.filterResetElement.removeEventListener( 'click', this.onFilterResetClick );
		}
	}

	/**
	 * 
	 */
	clearItemElements()
	{
		this.itemElements.forEach( ( itemElement ) =>
		{
			itemElement.remove();
		} );

		this.itemElements = [];
	}

	/**
	 * 
	 */
	addItem( item )
	{
		super.addItem( item );
		this.itemElements.push( this.appendItem( item ) );
	}

	/**
	 * 
	 */
	addItems( items )
	{
		super.addItems( items );
	}

	/**
	 * 
	 */
	appendItem( item )
	{
		if ( null !== this.itemWrapperElement )
		{
			const temp = document.createElement( 'template' );
			item = item.trim();
			temp.innerHTML = item;
			let itemElement; 

			if ( temp.content && temp.content.firstChild )
			{
				itemElement = temp.content.firstChild;

				if ( this.highlights && 0 === this.itemElements.length && null !== this.highlightsWrapperElement )
				{
					this.highlightsWrapperElement.appendChild( itemElement );
				}
				else
				{
					this.itemWrapperElement.appendChild( itemElement );
				}
			}

			temp.remove();
			return itemElement;
		}
	}

	/**
	 * 
	 */
	setupLoadMoreMode( mode )
	{

	}

	/**
	 * 
	 */
	checkFirstLoad()
	{
		if ( false === this.isFirstLoadDone && 0 === this.items.length && this.hasPageToLoad() )
		{
			const rect = this.element.getBoundingClientRect();
			const treshold = window.innerHeight * 0.25;

			if ( rect.top < ( window.innerHeight + treshold ) && rect.bottom >= ( 0 - treshold ) )
			{
				this.nextPage();
				this.isFirstLoadDone = true;
				
				if ( WMUBlockArchive.loadMoreModeIds.SCROLL !== this.loadMoreMode )
				{
					window.removeEventListener( 'scroll', this.onWindowScroll );
				}
			}
		}
	}

	/**
	 * 
	 */
	checkLoadMoreScroll()
	{
		if ( this.hasPageToLoad() )
		{
			const rect = this.element.getBoundingClientRect();
			const treshold = window.innerHeight * 0.5;

			if ( rect.top < window.innerHeight && rect.bottom < ( window.innerHeight + treshold ) )
			{
				this.nextPage();
			}
		}
	}

	/**
	 * 
	 * @param {*} page 
	 */
	getQueryData( page )
	{
		const queryData = super.getQueryData( page );

		if ( undefined !== this.masterTaxQuery )
		{
			queryData.query_args.tax_query = [
				this.masterTaxQuery,
				...queryData.query_args.tax_query,
			];
		}

		return queryData;
	}

	/**
	 * @todo Revoir tout ce fonctionnement pour trouver une manière de fonctionner en permettant de gérer
	 * les filtres dans n'importe quelle forme (select, checkbox, whatever...)
	 */
	writeFiltersData()
	{
		if ( null !== this.filtersFormElement && null != this.filterInputElementList )
		{
			this.filterInputElementList.forEach( ( element ) =>
			{
				const filterType = element.getAttribute( 'filter-type' );

				switch ( filterType )
				{
					case 'taxonomy':
						const taxonomy = element.getAttribute( 'taxonomy' );
						const term = element.getAttribute( 'term' );
						const checked = element.checked;
						let taxQueryArgs = ( this.queryArgs.tax_query )
							? this.queryArgs.tax_query.find( ( args ) => args.taxonomy === taxonomy )
							: null;

						if ( taxQueryArgs && taxQueryArgs.terms && -1 !== taxQueryArgs.terms.indexOf( term ) )
						{
							element.checked = true;
						}
						else
						{
							element.checked = false;
						}

						if ( checked !== element.checked )
						{
							element.dispatchEvent( new CustomEvent( 'change' ) );
						}
					break;

					case 'search':
						const searchValue = element.value;

						if ( this.queryArgs.s )
						{
							element.value = this.queryArgs.s;
						}
						else
						{
							element.value = '';
						}

						if ( searchValue !== element.value )
						{
							element.dispatchEvent( new CustomEvent( 'change' ) );
						}
					break;
				}
			} );
		}
	}

	/**
	 * @todo Revoir tout ce fonctionnement pour trouver une manière de fonctionner en permettant de gérer
	 * les filtres dans n'importe quelle forme (select, checkbox, whatever...)
	 * 
	 * @todo Comprendre pourquoi new FormData( this.filtersFormElement ) me renvoit toujours un formData sans valeurs.
	 */
	readFiltersData()
	{
		if ( null !== this.filtersFormElement )
		{
			if ( null !== this.filterInputElementList )
			{
				const taxonomies = {};

				this.filterInputElementList.forEach( ( element ) =>
				{
					const filterType = element.getAttribute( 'filter-type' );

					switch ( filterType )
					{
						case 'taxonomy':
							const taxonomy = element.getAttribute( 'taxonomy' );
							const term = element.getAttribute( 'term' );
							const checked = element.checked;

							if ( true === checked )
							{
								if ( undefined === taxonomies[ taxonomy ] )
								{
									taxonomies[ taxonomy ] = [];
								}

								taxonomies[ taxonomy ].push( term );
							}
						break;

						case 'search':
							this.queryArgs.s = element.value;
						break;
					}
				} );

				this.queryArgs.tax_query = [];

				Object.getOwnPropertyNames( taxonomies ).forEach( ( taxonomy ) =>
				{
					this.queryArgs.tax_query.push( {
						taxonomy: taxonomy,
						field: 'slug',
						terms: taxonomies[ taxonomy ],
					} );
				} );
			}
		}
	}
	
	/**
	 * 
	 */
	resetQuery()
	{
		this.clearItemElements();

		super.resetQuery();
	}

	/**
	 * 
	 * @param {*} event 
	 */
	onFilterFormSubmit( event )
	{
		event.preventDefault();

		if ( null !== this.resetQueryTimeoutID )
		{
			clearTimeout( this.resetQueryTimeoutID );
		}

		this.resetQueryTimeoutID = setTimeout( this.onResetQueryTimeout, this.resetQueryTimeoutDelay );

		return false;
	}

	/**
	 * 
	 * @param {*} event 
	 */
	onFilterInputChange( event )
	{
		const filterInputElement = event.target;

		// Prevent unnecessary reload if the input value don't change since init
		if ( filterInputElement && filterInputElement.wmuBlockArchiveInitValue === filterInputElement.value )
		{
			return;
		}

		if ( null !== this.resetQueryTimeoutID )
		{
			clearTimeout( this.resetQueryTimeoutID );
		}

		this.resetQueryTimeoutID = setTimeout( this.onResetQueryTimeout, this.resetQueryTimeoutDelay );
	}

	/**
	 * 
	 * @param {*} event 
	 */
	onFilterResetClick( event )
	{
		event.preventDefault();

		if ( null != this.filterInputElementList )
		{
			let hasChanged = false;

			this.filterInputElementList.forEach( ( element ) =>
			{
				if ( false === hasChanged && true === element.checked )
				{
					hasChanged = true;
				}

				element.removeEventListener( 'change', this.onFilterInputChange );
				element.checked = false;
				element.dispatchEvent( new CustomEvent( 'change' ) );
				element.addEventListener( 'change', this.onFilterInputChange );
			} );

			if ( true === hasChanged )
			{
				this.onResetQueryTimeout();
			}
		}
	}

	/**
	 * 
	 */
	onResetQueryTimeout()
	{
		// console.log( 'BlockArchive.onResetQueryTimeout' );

		this.resetQueryTimeoutID = null;

		this.resetQuery();
		this.readFiltersData();
		this.nextPage();
	}

	/**
	 * @todo Démonter l'event window scroll quand plus de contenu à charger
	 * 
	 * @param {*} event 
	 */
	onWindowScroll( event )
	{
		this.checkFirstLoad();
		this.checkLoadMoreScroll();
	}

}

export default WMUBlockArchive;